
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnership-program/channel-partners",
      function () {
        return require("private-next-pages/partnership-program/channel-partners/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnership-program/channel-partners"])
      });
    }
  